import React, { ReactNode, useRef, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';

interface TooltipWrapperProps {
  children: ReactNode;
  tooltipContent: ReactNode;
  tooltipPlacement?: Placement;
}

const TooltipWrapper = ({ children, tooltipContent, tooltipPlacement = 'top' }: TooltipWrapperProps) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  return (
    <>
      <div
        ref={target}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        style={{ display: 'inline-block' }}
        role="tooltip"
      >
        {children}
      </div>
      <Overlay target={target.current} show={show} placement={tooltipPlacement}>
        <Tooltip>{tooltipContent}</Tooltip>
      </Overlay>
    </>
  );
};

export default TooltipWrapper;
